export default __webpack_public_path__ + "static/media/a11y-fr.d5afc46e.jpg";